var map = {
	"./AD.svg": 38551,
	"./AE.svg": 61164,
	"./AF.svg": 18543,
	"./AG.svg": 56424,
	"./AI.svg": 30584,
	"./AL.svg": 50894,
	"./AM.svg": 1487,
	"./AN.svg": 82429,
	"./AO.svg": 38939,
	"./AR.svg": 52624,
	"./AT.svg": 26493,
	"./AU.svg": 63182,
	"./AW.svg": 26419,
	"./AX.svg": 435,
	"./AZ.svg": 8938,
	"./BA.svg": 48884,
	"./BB.svg": 48999,
	"./BD.svg": 78870,
	"./BE.svg": 40767,
	"./BF.svg": 87792,
	"./BG.svg": 33295,
	"./BH.svg": 37084,
	"./BI.svg": 36557,
	"./BJ.svg": 55705,
	"./BM.svg": 31160,
	"./BN.svg": 11165,
	"./BO.svg": 64026,
	"./BR.svg": 77386,
	"./BS.svg": 17490,
	"./BT.svg": 84004,
	"./BW.svg": 57778,
	"./BY.svg": 71641,
	"./BZ.svg": 86534,
	"./CA.svg": 99602,
	"./CD.svg": 27828,
	"./CF.svg": 79233,
	"./CG.svg": 90833,
	"./CH.svg": 55290,
	"./CI.svg": 31127,
	"./CL.svg": 16011,
	"./CM.svg": 33871,
	"./CN.svg": 12548,
	"./CO.svg": 73090,
	"./CR.svg": 5876,
	"./CU.svg": 35199,
	"./CV.svg": 42422,
	"./CY.svg": 49348,
	"./CZ.svg": 26798,
	"./DE.svg": 81481,
	"./DJ.svg": 88625,
	"./DK.svg": 65057,
	"./DM.svg": 85830,
	"./DO.svg": 39571,
	"./DZ.svg": 84040,
	"./EC.svg": 56035,
	"./EE.svg": 28665,
	"./EG.svg": 55569,
	"./ER.svg": 3366,
	"./ES.svg": 19731,
	"./ET.svg": 96483,
	"./FI.svg": 26569,
	"./FJ.svg": 24132,
	"./FK.svg": 52780,
	"./FM.svg": 47603,
	"./FR.svg": 68891,
	"./GA.svg": 2325,
	"./GB.svg": 96702,
	"./GD.svg": 28162,
	"./GE.svg": 51207,
	"./GG.svg": 16132,
	"./GH.svg": 94735,
	"./GI.svg": 28350,
	"./GM.svg": 49608,
	"./GN.svg": 26963,
	"./GQ.svg": 50252,
	"./GR.svg": 80079,
	"./GT.svg": 24705,
	"./GW.svg": 8796,
	"./GY.svg": 53823,
	"./HK.svg": 57132,
	"./HN.svg": 34322,
	"./HR.svg": 89395,
	"./HT.svg": 56329,
	"./HU.svg": 15352,
	"./ID.svg": 57253,
	"./IE.svg": 49515,
	"./IL.svg": 75580,
	"./IM.svg": 82851,
	"./IN.svg": 34821,
	"./IQ.svg": 82761,
	"./IR.svg": 21126,
	"./IS.svg": 44702,
	"./IT.svg": 97835,
	"./JE.svg": 91973,
	"./JM.svg": 18223,
	"./JO.svg": 61837,
	"./JP.svg": 39354,
	"./KE.svg": 20615,
	"./KG.svg": 95015,
	"./KH.svg": 43577,
	"./KM.svg": 61024,
	"./KN.svg": 23918,
	"./KP.svg": 41926,
	"./KR.svg": 8380,
	"./KW.svg": 84376,
	"./KY.svg": 58133,
	"./KZ.svg": 94028,
	"./LA.svg": 52501,
	"./LB.svg": 50968,
	"./LC.svg": 60502,
	"./LI.svg": 14987,
	"./LK.svg": 85993,
	"./LR.svg": 76130,
	"./LS.svg": 8407,
	"./LT.svg": 95003,
	"./LU.svg": 52307,
	"./LV.svg": 13146,
	"./LY.svg": 63946,
	"./MA.svg": 65613,
	"./MC.svg": 63614,
	"./MD.svg": 65123,
	"./ME.svg": 85440,
	"./MG.svg": 4569,
	"./MK.svg": 37226,
	"./ML.svg": 14061,
	"./MM.svg": 49435,
	"./MN.svg": 42723,
	"./MO.svg": 96032,
	"./MR.svg": 28755,
	"./MS.svg": 7817,
	"./MT.svg": 38788,
	"./MU.svg": 36849,
	"./MV.svg": 55919,
	"./MW.svg": 88348,
	"./MX.svg": 68550,
	"./MY.svg": 39287,
	"./MZ.svg": 17053,
	"./NA.svg": 92805,
	"./NE.svg": 73577,
	"./NG.svg": 51382,
	"./NI.svg": 57584,
	"./NL.svg": 85261,
	"./NO.svg": 75928,
	"./NP.svg": 5715,
	"./NZ.svg": 66416,
	"./OM.svg": 43506,
	"./PA.svg": 18055,
	"./PE.svg": 66102,
	"./PF.svg": 59274,
	"./PG.svg": 82846,
	"./PH.svg": 70069,
	"./PK.svg": 62352,
	"./PL.svg": 35313,
	"./PR.svg": 76989,
	"./PT.svg": 24185,
	"./PW.svg": 6474,
	"./PY.svg": 92431,
	"./QA.svg": 36491,
	"./RO.svg": 99438,
	"./RS.svg": 71602,
	"./RU.svg": 32184,
	"./RW.svg": 6870,
	"./SA.svg": 61252,
	"./SB.svg": 74140,
	"./SC.svg": 30875,
	"./SD.svg": 30563,
	"./SE.svg": 3770,
	"./SG.svg": 90810,
	"./SH.svg": 91837,
	"./SI.svg": 41697,
	"./SK.svg": 77152,
	"./SL.svg": 31260,
	"./SM.svg": 93491,
	"./SN.svg": 58421,
	"./SO.svg": 20768,
	"./SR.svg": 4349,
	"./ST.svg": 30828,
	"./SV.svg": 95521,
	"./SY.svg": 21985,
	"./SZ.svg": 29957,
	"./TC.svg": 76352,
	"./TD.svg": 12439,
	"./TG.svg": 32915,
	"./TH.svg": 44879,
	"./TJ.svg": 91201,
	"./TL.svg": 67530,
	"./TM.svg": 94101,
	"./TN.svg": 96749,
	"./TO.svg": 40315,
	"./TR.svg": 64642,
	"./TT.svg": 33752,
	"./TW.svg": 72567,
	"./TZ.svg": 48498,
	"./UA.svg": 48717,
	"./UG.svg": 27037,
	"./US.svg": 14744,
	"./UY.svg": 71566,
	"./UZ.svg": 94497,
	"./VC.svg": 67617,
	"./VE.svg": 68613,
	"./VG.svg": 47307,
	"./VN.svg": 32756,
	"./VU.svg": 76251,
	"./WS.svg": 94004,
	"./YE.svg": 94531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70236;